export const RATING_OPTIONS = [
  { key: 1, name: "1 — Poor" },
  { key: 2, name: "2 — Fair" },
  { key: 3, name: "3 — Good" },
  { key: 4, name: "4 — Very Good" },
  { key: 5, name: "5 — Excellent" },
];

export const ANONYMOUS_OPTIONS = [
  { key: true, name: "Anonymous" },
  { key: false, name: "Not Anonymous" },
];

export const SORT_OPTIONS = [
  { key: "created_at", name: "Date" },
  { key: "title", name: "Title" },
  { key: "first_name", name: "First Name" },
  { key: "last_name", name: "Last Name" },
  { key: "email", name: "Email" },
  { key: "rating_feedback", name: "Rating" },
];

export const ORDER_DIRECTION_OPTIONS = [
  { key: "asc", name: "Ascending" },
  { key: "desc", name: "Descending" },
];
